import React from 'react';
import { Box, Container, Divider, Typography } from '@mui/material';
import { useDataLastModified } from '../hooks/useDataLastModified';
import { t } from '../i18n';

// Footer shown on pages 1-3. Displays "data last updated" from GET /meta.
const Footer = () => {
  const updated = useDataLastModified();

  return (
    <Box component="footer" sx={{ mt: 'auto', pt: 2 }}>
      <Container maxWidth="md">
        <Divider />
        <Box sx={{ py: 2, textAlign: 'center' }}>
          {updated && (
            <Typography variant="body2" color="text.secondary">
              {t('Data last updated: ', 'データ最終更新日: ')}
              {updated}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {new Date().getFullYear()} Japan Postal Code Lookup ·{' '}
            {t('Source: Japan Post', 'データ提供: 日本郵便')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
